import Axios from "@/plugins/Axios";

/** Lista fechada (Deficiência/TEA/Altas Habilidades), catálogo único, sem CRUD no front. */
export class CondicoesService {
  async listar() {
    const response = await Axios().get("condicoes");
    return response.data;
  }
}

export default new CondicoesService();
